module.exports = __webpack_public_path__ + "img/cns_email_ios6.d476e2ba.png";